<template>
    <div class="relative" :class="{ '-mx-5 lg:mx-0': isOpen }">
        <div class="flex justify-between items-center p-2 w-full"
             :class="[isOpen ? 'px-7 lg:px-2 rounded-t' : 'rounded text-gray', primary ? 'caret-red' : 'text-purple caret-purple', { 'border-opacity-100': value.length, 'border border-opacity-20 border-gray': !primary }]"
             @click="toggle">
            <span class="pointer-events-none text-gray" :class="{ 'text-opacity-30': !value.length || primary }">
                {{ value.length && !isOpen ? valueLabel : label }}
            </span>
            <icon name="chevron"
                  :class="{ 'opacity-50': !isOpen }"
                  class="mt-px mr-4 w-2 h-4 transform rotate-90 fill-current" />
        </div>
        <label :for="name" class="w-0 h-0 pointer-events-none">
            <span class="block h-0 w-0 overflow-hidden">{{ label }}</span>
            <input class="opacity-0 transform -translate-y-full"
                   type="text"
                   :id="name"
                   :name="name"
                   :required="required"
                   :value="value" />
        </label>
        <div v-show="isOpen"
             @click="toggle"
             :class="[primary ? 'border-red' : 'border-purple']"
             class="overflow-auto absolute top-0 z-10 pt-10 w-full max-h-64 rounded border shadow-lg">
            <ul class="bg-white">
                <li v-for="item in items"
                    :key="item.value"
                    @click.stop="select(item)"
                    :class="[primary ? 'hover:bg-red' : 'hover:bg-purple', { 'bg-red' : allowDeselect && item.value == value }]"
                    class="px-7 py-2 transition-colors cursor-pointer lg:px-4 hover:text-white">
                    {{ item.label }}
                </li>
            </ul>
        </div>
        <div class="hidden">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class FormDropdown extends Vue {
    @Prop({ required: true }) items: { label: string; value: string }[];
    @Prop({ required: true }) name: string;
    @Prop({ required: true }) label: string;
    @Prop({ default: false }) required: boolean;
    @Prop({ default: false, type: Boolean }) primary: boolean;
    @Prop({ default: false, type: Boolean }) allowDeselect: boolean;

    options: HTMLInputElement[] = [];
    value = '';
    valueLabel = '';
    isOpen = false;

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    }

    destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    onChange() {
        this.isOpen = true;
    }

    select(result) {
        if (this.allowDeselect && this.value === result.value) {
            this.value = '';
            this.valueLabel = '';
        } else {
            this.value = result.value;
            this.valueLabel = result.label;
        }
        this.isOpen = false;
        this.$emit('selected');
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
            this.isOpen = false;
        }
    }
}
</script>
